import {CnameRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

let service = {};

service.getBackofficeDomainUrlForBackofficeSide = (
  isAgencyWhiteLabeled = false,
) => {
  if (isAgencyWhiteLabeled) {
    return VIDABOO_CONSTANTS.NATIVE_APP
      ? VIDABOO_CONSTANTS.APP_PAGE
      : window.location.origin;
  }
  return VIDABOO_CONSTANTS.APP_PAGE;
};

service.getBackofficeDomainUrlForCustomerSide = async (
  isAgencyWhiteLabeled = false,
  resellerAgencyId = null,
) => {
  let domainUrl = VIDABOO_CONSTANTS.APP_PAGE;
  if (isAgencyWhiteLabeled && resellerAgencyId) {
    const response = await service.getHostnameByObjectTypeAndId(
      VIDABOO_CONSTANTS.CNAME_INSTANCE_OBJECT_TYPE.AGENCY,
      resellerAgencyId,
    );
    if (response.success && response.data?.hostname) {
      domainUrl = `https://${response.data?.hostname}`;
    }
  }
  return domainUrl;
};

service.getDomainUrlByWidgetId = async (widgetId) => {
  let hostname;
  if (widgetId) {
    const response = await service.getHostnamesByWidgetIds([widgetId], null);
    if (response.success) {
      const widgetIdToCnameHostMap = response.data?.widgetIdToCnameHostMap;
      if (widgetIdToCnameHostMap && widgetIdToCnameHostMap[widgetId]) {
        hostname = widgetIdToCnameHostMap[widgetId];
      }
    }
  }
  const domainUrl = utilsService.getClientPageDomainUrl(hostname);
  return domainUrl;
};

service.getHostnamesByWidgetIds = async (widgetIds, token) => {
  const requestObj = {
    endpoint: 'hostname/widgetIds',
    widgetIds,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.get(requestObj, requestObj);
  return response.data;
};

service.verifyCnameInstanceByCnameInstanceId = async (
  cnameInstanceId,
  token,
) => {
  let requestObject = {
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'verify/cnameInstanceId',
      endpointParam: cnameInstanceId,
    },
    requestObject,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.assignCnameInstanceToWidgets = async (
  widgetIds,
  cnameInstanceId,
  token,
) => {
  let requestObject = {
    widgetIds,
    cnameInstanceId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'assign/widgetIds',
    },
    requestObject,
  );
  return response.data;
};

service.unassignWidgetsFromAllCnames = async (widgetIds, token) => {
  let requestObject = {
    widgetIds,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'unassign/widgetIds',
    },
    requestObject,
  );
  return response.data;
};

service.deleteCnameInstanceByInstanceId = async (cnameInstanceId, token) => {
  const _token = token ? token : storageService.getItem('token');
  const response = await CnameRestService.delete(
    {
      endpoint: cnameInstanceId,
      token: _token,
    },
    {
      endpoint: cnameInstanceId,
      token: _token,
    },
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.createCnameInstanceByObjectTypeAndId = async (requestObj, token) => {
  let requestObject = {
    ...requestObj,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.save(
    {
      endpoint: 'objectType',
    },
    requestObject,
  );
  utilsService.logApiResponse(
    'createCnameInstanceByObjectTypeAndId',
    response.data,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.getCnameInstancesByObjectTypeAndId = async (
  objectType,
  objectId,
  token,
) => {
  let requestObject = {
    objectType,
    objectId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.get(
    {
      endpoint: 'objectType',
      endpointParam: objectType,
      endpoint2: 'objectId',
      endpointParam2: objectId,
    },
    requestObject,
  );
  utilsService.logApiResponse(
    'getCnameInstancesByObjectTypeAndId',
    response.data,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.getHostnameByObjectTypeAndId = async (objectType, objectId) => {
  const response = await CnameRestService.get(
    {
      endpoint: 'hostname/objectType',
      endpointParam: objectType,
      endpoint2: 'objectId',
      endpointParam2: objectId,
    },
    {},
  );
  utilsService.logApiResponse('getHostnameByObjectTypeAndId', response.data);
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.verifyHostnameByObjectTypeAndId = async (
  hostname,
  objectType,
  objectId,
) => {
  const requestObject = {
    hostname,
    objectType,
    objectId,
  };
  const response = await CnameRestService.save(
    {
      endpoint: 'verify/hostname',
    },
    requestObject,
  );
  utilsService.logApiResponse('verifyHostnameByObjectTypeAndId', response.data);
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

const cnameInstanceService = {...service};

export default cnameInstanceService;
